var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PageLayout',[_c('template',{slot:"header"},[_c('TopBar')],1),_c('template',{slot:"content"},[_c('div',{staticClass:"p-20 d-flex jc-center"},[_c('md-content',{staticClass:"md-scrollbar"},[_c('router-view')],1)],1)])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }